import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { ZonedDateTime } from '@js-joda/core';
import { OrderAttachment } from '../../type/order';
import { LineItem } from './LineItem';
/**
 * Represents an order with line item.
 */
export class OrderResponse {
}
__decorate([
    Serialize(() => LineItem),
    __metadata("design:type", Object)
], OrderResponse.prototype, "lineItem", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime
    /**
     * Human-friendly reference number for the order
     */
    )
], OrderResponse.prototype, "placedOn", void 0);
__decorate([
    Type(() => OrderAttachment),
    __metadata("design:type", Array)
], OrderResponse.prototype, "attachments", void 0);
